import { api } from '@/api'
import checkColorTheme from '@/utils/checkColorTheme'

const actions = {
  paymentBillet: async ({ state, commit }, dataBillet) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const sendData = {
        ...dataBillet,
        order_id: state.order_id,
        cart: state.cart.hash,
      }

      const postBillet = await api.post('api/v1/step/payment/billet', sendData)
      return postBillet
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },

  paymentBilletShopify: async ({ state, commit }, dataBillet) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const sendData = {
        ...dataBillet,
        order_id: state.order_id,
        cart: state.cart.hash,
      }

      const postBillet = await api.post('api/v1/step/payment/billet-shopify', sendData)
      return postBillet
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },

  paymentCreditCard: async ({ state, commit, dispatch }, dataCreditCard) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })

      await dispatch('createOrder', 'CreditCard')
      const sendData = {
        ...dataCreditCard,
        installments: dataCreditCard.installments.toString(),
        store_id: state.store_id.toString(),
        order_id: state.order_id.toString(),
        cart: state.hash,
      }

      const postCreditCard = await api.post('api/v1/step/payment/credit-card', sendData)
      await commit('Checkout/SET_UPSELL_HASH', postCreditCard.data.data.upsell_hash, { root: true })
      await commit('SET_UPSELL_HASH', postCreditCard.data.data.upsell_hash)
      return postCreditCard
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
      commit('SET_RECAPTCHA_ATTEMPTS', 1)
    }
  },

  paymentCreditCardShopify: async ({ state, commit }, dataCreditCard) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const sendData = {
        ...dataCreditCard,
        order_id: state.order_id,
        cart: state.cart.hash,
      }

      const postCreditCard = await api.post('api/v1/step/payment/credit-card-shopify', sendData)
      return postCreditCard
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },

  paymentPix: async ({ state, commit }, dataPix) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const sendData = {
        ...dataPix,
        order_id: state.order_id,
        cart: state.cart.hash,
      }
      const postPix = await api.post('api/v1/step/payment/pix', sendData)
      return postPix
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },

  paymentPixShopify: async ({ state, commit }, dataPix) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const sendData = {
        ...dataPix,
        order_id: state.order_id,
        cart: state.cart.hash,
      }
      const postPix = await api.post('api/v1/step/payment/pix-shopify', sendData)
      return postPix
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },

  createOrder: async ({ state, commit }, paymentType) => {
    try {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const orderData = {
        payment_method: paymentType,
        cart: state.hash,
      }

      const {
        data: {
          data: { id },
        },
      } = await api.post('api/v1/step/order/create', orderData)
      await commit('SET_ORDER_ID', id)
      return id
    } catch (error) {
      throw Error(error.response.status)
    } finally {
      commit('SET_GLOBAL_LOADING', false, { root: true })
    }
  },

  createUpsell: async ({ state, commit }, bundleId) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })

      const data = {
        upsell_hash: state.upsell_hash,
        bundle_id: bundleId,
        cart: state.hash,
      }

      const upsell = await api.post('api/v1/step/cart/upsell', data)
      return upsell
    } catch (error) {
      throw Error(error.response.error)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
    }
  },

  createOrderShopify: async ({ state, dispatch, commit }, data) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const orderData = {
        payment_method: data.paymentType,
        telephone: data.telephone,
        email: data.email,
        cart: state.cart.hash,
      }

      const order = await api.post('api/v1/step/order/create-shopify', orderData)
      await dispatch('fetchCart', state.cart.hash)
      return order
    } catch (error) {
      throw Error(error.response.status)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },

  fetchCart: async ({ commit, rootGetters }, cartId) => {
    try {
      commit('SET_GLOBAL_LOADING', true, { root: 'true' })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })

      if (!cartId) {
        const { pl } = rootGetters.getPl
        if (rootGetters.getPl) {
          window.location.replace(
            `http://${process.env.VUE_APP_BASE_DOMAIN_URL_PAYMENT_LINK}pl/${pl}`
          )
        }
      }

      const cartData = {
        cart: cartId,
      }
      const {
        data: { data: cart },
      } = await api.post('api/v1/step/cart', cartData)

      const {
        country_id,
        order_id,
        currency_code,
        settings,
        installment_default,
        recaptcha_attempts,
        store_name,
        visit,
        enable_address,
        freights,
        hash,
        shop_url,
        shop_cancel_url,
        store_id,
        discount,
        freight,
        total,
        tributes,
        subtotal,
        coupon,
        items,
        order,
        installments,
        freight_id,
        is_international,
        enable_international,
        store_allow_cnpj,
      } = cart

      localStorage.setItem('items', JSON.stringify(items))

      commit('SET_CART', {
        country_id,
        order_id,
        currency_code,
        settings,
        installment_default,
        recaptcha_attempts,
        store_name,
        visit,
        enable_address,
        freights,
        hash,
        shop_url,
        shop_cancel_url,
        store_id,
        discount,
        freight,
        total,
        items,
        tributes,
        subtotal,
        coupon,
        order,
        installments,
        freight_id,
        is_international,
        enable_international,
        store_allow_cnpj,
      })
      commit('Checkout/SET_CART', cart, { root: true })
      commit('Customer/SET_CUSTOMER', cart.customer, { root: true })
      commit('Checkout/SET_COLOR_THEME', checkColorTheme(cart.settings.color), { root: true })
      commit('Checkout/SET_IMAGE', cart.settings.image, { root: true })
      return cart
    } catch (error) {
      throw Error(error)
    } finally {
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
      commit('SET_GLOBAL_LOADING', false, { root: 'true' })
    }
  },

  fetchCartShopify: async ({ commit }, cartId) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const cartData = {
        cart: cartId,
        shopify: true,
      }
      const {
        data: { data: cart },
      } = await api.post('api/v1/step/cart', cartData)
      commit('SET_CART', cart)
      commit('SET_COLOR_THEME', checkColorTheme(cart.settings.color))
      commit('SET_IMAGE', cart.settings.image)
      return cart
    } catch (error) {
      throw Error(error)
    } finally {
      commit('SET_STATUS_CART_LOADING', false)

      commit('SET_GLOBAL_LOADING', false, { root: 'true' })
    }
  },

  updateBundle: async ({ state, dispatch, commit }, bundle) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const bundleData = {
        ...bundle,
        cart: state.cart.hash,
      }
      const updateDataBundle = await api.post('/api/v1/step/cart/bundle/update', bundleData)
      await dispatch('fetchCart', state.cart.hash)
      return updateDataBundle
    } catch (error) {
      throw Error(error)
    } finally {
      await dispatch('fetchCart', state.cart.hash)
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  removeBundle: async ({ state, dispatch, commit }, bundle) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const bundleData = {
        ...bundle,
        cart: state.cart.hash,
      }
      const removeDataBundle = await api.post('/api/v1/step/cart/bundle/remove', bundleData)
      await dispatch('fetchCart', state.cart.hash)
      return removeDataBundle
    } catch (error) {
      throw Error(error)
    } finally {
      await dispatch('fetchCart', state.cart.hash)
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  applyerCoupon: async ({ state, dispatch, commit }, couponCode) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const couponData = {
        coupon_code: couponCode,
        cart: state.cart.hash,
      }
      const applyerDataCoupon = await api.post('/api/v1/step/cart/coupon/add', couponData)
      await dispatch('fetchCart', state.cart.hash)
      return applyerDataCoupon
    } catch (error) {
      throw Error(error.response.status)
    } finally {
      await dispatch('fetchCart', state.cart.hash)
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  removeCoupon: async ({ state, dispatch, commit }, couponCode) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const couponData = {
        coupon_code: couponCode,
        cart: state.cart.hash,
      }
      const removeDataCoupon = await api.post('/api/v1/step/cart/coupon/remove', couponData)
      await dispatch('fetchCart', state.cart.hash)
      return removeDataCoupon
    } catch (error) {
      throw Error(error)
    } finally {
      await dispatch('fetchCart', state.cart.hash)
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  addFreight: async ({ state, commit }, freight) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const freightData = {
        freight_id: freight,
        cart: state.cart.hash,
      }
      return await api.post('api/v1/step/cart/freight/add', freightData)
    } catch (error) {
      throw Error(error)
    } finally {
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  addOrderBump: async ({ state, dispatch, commit }, orderBumpId) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const orderBumpData = {
        bundle_id: orderBumpId,
        cart: state.cart.hash,
      }
      const removeDataOrderBumpData = await api.post(
        '/api/v1/step/cart/order-bump/add',
        orderBumpData
      )
      await dispatch('fetchCart', state.cart.hash)
      return removeDataOrderBumpData
    } catch (error) {
      throw Error(error)
    } finally {
      await dispatch('fetchCart', state.cart.hash)
      commit('SET_STATUS_CART_LOADING', false)
    }
  },
}

export default actions
